export default __webpack_public_path__ + "images/0701bdcc71dda37d1d7fb65cad034cff.png";